import { observable, action, runInAction, computed, toJS } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { rightsParamSets } from '@services/api'

export class rightParamSetStore extends StoreExt {
    @observable list = []
    @observable filteredList = []
    @observable filterText = ''
    @observable edit = {}
    @observable errors = {}

    @action
    getList = async () => {
        const { data: list } = await rightsParamSets.getList()
        runInAction(() => {
            this.list = list
            this.filterList(this.filterText)
        })
    }

    @action
    addRightParamSet = async () => {
        if (this.edit['name']) {
            try {
                await rightsParamSets.addRightParamSet({ ...this.edit })
                runInAction(() => {
                    this.resetEdit()
                    this.getList()
                })
            } catch (e) {
                runInAction(() => {
                    if (e.response.status === 400) {
                        this.errors['serverError'] = 'השם הנוכחי כבר קיים'
                    } else {
                        this.errors['serverError'] = 'קיימת שגיאה בשרת'
                    }
                })
            }
        } else {
            this.errors['name'] = 'עליך להזין שם'
        }
    }

    @action
    updateRightParamSet = async id => {
        if (this.edit['name']) {
            try {
                await rightsParamSets.updateRightParamSet({ id, ...this.edit })
                runInAction(() => {
                    this.resetEdit()
                    this.getList()
                })
            } catch (e) {
                runInAction(() => {
                    if (e.response.status === 400) {
                        this.errors['serverError'] = 'השם הנוכחי כבר קיים'
                    } else {
                        this.errors['serverError'] = 'קיימת שגיאה בשרת'
                    }
                })
            }
        } else {
            this.errors['name'] = 'עליך להזין שם'
        }
    }

    @action
    deleteRightParamSet = async id => {
        try {
            await rightsParamSets.deleteRightParamSet(id)
            this.resetEdit()
            this.getList()
        } catch (e) {
            console.log(e)
            runInAction(() => {
                if (e.response.status === 403) {
                    this.errors['serverError'] = 'לא ניתן למחוק טבלה זו כיוון שנמצאו פריטים משוייכים'
                } else {
                    this.errors['serverError'] = 'שגיאה בשרת'
                }
            })
        }
    }

    @action
    setValue = (name, value) => {
        runInAction(() => {
            this.edit[name] = value
        })
    }

    @action
    filterList = filterText => {
        this.filterText = filterText
        this.filteredList = this.list.filter(item => item.name.includes(filterText) || item.id === filterText)
    }

    @action
    resetRightParamSets = () => {
        this.list = []
        this.filteredList = []
        this.filterText = ''
    }

    @action
    resetEdit = () => {
        this.filterText = ''
        this.edit = {}
        this.errors = {}
    }
}

export default remotedev(new rightParamSetStore())
